export var state = {
    currentTimetableId: -1,
    currentTimetableTitle: "",
    timetableReloading: false,
    trackSwitchedByUser: false
};
